module.exports = __webpack_public_path__ + "static/media/HH Op.8f5f1c06.wav";